import { ApiCodeExamples, ApiResponseExamples } from './ApiReferenceBlocks';

/**
 * Upper-case MDX shortcodes exposed to every Help article.
 */
export const helpArticleMdxComponents = {
  ApiCodeExamples,
  ApiResponseExamples,
};
